import { useI18n } from "../context/I18nContext";
import { IMAGES } from "../lib/images";
import { Overline, Reveal } from "./Reveal";

export default function LaCocina() {
  const { t } = useI18n();

  return (
    <section id="la-cocina" data-testid="philosophy-section" className="grain bg-ember py-24 text-cream md:py-36">
      <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-10">
        <div className="max-w-2xl">
          <Reveal>
            <Overline light>{t.cocina.overline}</Overline>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-3xl leading-tight sm:text-4xl lg:text-5xl">
              {t.cocina.title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 leading-relaxed text-cream/65">{t.cocina.lead}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal y={40}>
                <div className="overflow-hidden">
                  <video
                    data-testid="philosophy-video"
                    poster="/photos/arroz-ternera.jpg"
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="aspect-[4/5] w-full object-cover"
                  >
                    <source src={IMAGES.philoVideo} type="video/mp4" />
                    <source src="/photos/cocina-paella.webm" type="video/webm" />
                  </video>
                </div>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            {t.cocina.chapters.map((c, i) => (
              <Reveal key={c.n} delay={0.05 * i}>
                <div
                  data-testid={`philosophy-concept-${c.n}`}
                  className={`flex gap-6 py-9 md:gap-10 ${i === 0 ? "pt-0" : "border-t border-white/10"}`}
                >
                  <span className="font-corm text-5xl italic leading-none text-terra/80 md:text-6xl">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl">{c.t}</h3>
                    <p className="mt-2 max-w-md leading-relaxed text-cream/65">{c.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal y={40}>
          <div className="mt-16 overflow-hidden md:mt-20">
            <img
              src={IMAGES.philoWide}
              alt={t.cocina.wideImageAlt}
              loading="lazy"
              className="aspect-[21/9] w-full object-cover"
            />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-right font-corm text-2xl italic text-terra md:text-3xl">
            {t.cocina.sign}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
